module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-view-resumenes-corrective/master-view-resumenes-corrective.component.scss
// module id = ./src/app/master/master-view-resumenes-corrective/master-view-resumenes-corrective.component.scss
// module chunks = main